export const buildQuery = (query) => {
    return Object.entries(query)
        .map(([key, value]) =>value && `${key}=${value}`)
        .filter(Boolean)
        .join('&');
};
